import { SamwinLineStatusRemoteDto } from '../../../../generated/signalR/samwin-line-status-remote-dto';

export class LinesChangedAction {
   public static readonly type = '[SamwinLines] lines changed';

   constructor(public sourceLine: SamwinLineStatusRemoteDto, public destinationLine: SamwinLineStatusRemoteDto) {}
}
